'use strict';

import React from 'react';

import { io, Component, redirect } from 'core';

class Link extends Component {

    onClick() {

        redirect(this.props.href);
    }

	render() {

  		return (
			<div key={this.props.key} className="link-container">
                <a key={ 'link-' + this.props.key} href="#" onTouchTap={this.onClick.bind(this)}>
                    {this.props.title}{this.props.children}
                </a>
            </div>
  		);
	}
}

export default Link



// WEBPACK FOOTER //
// ./ui/gui/components/link.jsx